'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _uniqueId = require('lodash/uniqueId');
var _uniqueId2 = _interopRequireDefault(_uniqueId);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Wrapper Component that groups CheckBoxes together so that multiple checkboxes
 * can be selected at a time. Also offers a change handler that triggers
 * when the selection changes. This is a controlled component and does not manage
 * the state of what CheckBoxes are selected by itself.
 */
var CheckBoxGroupBase = function (_React$Component) {
  _inherits(CheckBoxGroupBase, _React$Component);
  function CheckBoxGroupBase(props) {
    _classCallCheck(this, CheckBoxGroupBase);
    var _this = _possibleConstructorReturn(this, (CheckBoxGroupBase.__proto__ || Object.getPrototypeOf(CheckBoxGroupBase)).call(this, props));
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  _createClass(CheckBoxGroupBase, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement('div', {
          className: this.props.className
        }, this.renderCheckBoxes());
      }
      return render;
    }()
  }, {
    key: 'renderCheckBoxes',
    value: function () {
      function renderCheckBoxes() {
        var _this2 = this;
        var _props = this.props,
          groupName = _props.groupName,
          selectedValues = _props.selectedValues;
        var checkBoxArray = _react2['default'].Children.map(this.props.children, function (child) {
          var childValue = child.props.value;
          var isChecked = false;
          if (selectedValues.indexOf(childValue) > -1) {
            isChecked = true;
          }
          return _react2['default'].cloneElement(child, {
            changeHandler: _this2.handleChange,
            name: groupName,
            checked: isChecked
          });
        }, this);
        return checkBoxArray;
      }
      return renderCheckBoxes;
    }()
  }, {
    key: 'handleChange',
    value: function () {
      function handleChange(checked, value, event) {
        var newSelectedValues = void 0;
        if (checked) {
          newSelectedValues = [].concat(_toConsumableArray(this.props.selectedValues), [value]);
        } else {
          newSelectedValues = this.props.selectedValues.filter(function (selectedValue) {
            return selectedValue !== value;
          });
        }
        this.props.changeHandler(newSelectedValues, this.props.groupName, event);
      }
      return handleChange;
    }()
  }]);
  return CheckBoxGroupBase;
}(_react2['default'].Component);
CheckBoxGroupBase.defaultProps = {
  changeHandler: function () {
    function changeHandler() {}
    return changeHandler;
  }(),
  groupName: (0, _uniqueId2['default'])('checkBoxGroupName_'),
  layout: 'vertical',
  selectedValues: []
};
CheckBoxGroupBase.propTypes = {
  /**
   * Function called when a checkbox is clicked.
   * @param {string} values All of the selected values for the checkboxes.
   * @param {string} groupName The groupName associated with the checkboxes.
   * @param {object} evt The event object.
   */
  changeHandler: _propTypes2['default'].func,
  /**
   * A name for the checkbox group. This will be used as the
   * name property for each checkbox in this group.
   */
  groupName: _propTypes2['default'].string,
  /**
   * A string value to change the alignment of the checkboxes.
   */
  layout: _propTypes2['default'].oneOf(['vertical', 'horizontal']),
  /**
   * A list of the currently selected values. The strings in
   * the list must match the value property of the checkboxes
   * that you want selected.
   */
  selectedValues: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]))
};
CheckBoxGroupBase.displayName = 'CheckBoxGroup';
exports['default'] = CheckBoxGroupBase;